@if (isLoadingState()) {
  <app-loading />
} @else {
  <app-step-dot-menu
    [projectId]="projectId()!"
    testId="step3-1-dot-menu-button"
    [preselectedRole]="ProjectRoleType.CONTRIBUTOR"
    [preselectedAccessiblePages]="[ProjectStepType.SYSTEM_RECORDING]"
  ></app-step-dot-menu>

  <div *transloco="let t; prefix: 'project'" data-testid="step-3-1-system-recording">
    <p-tabs appTabsUnsavedReveal [value]="0" data-testid="step-3-1-tabs" scrollable>
      <p-tablist data-testid="step-3-1-tablist">
        <p-tab [value]="0" data-testid="system-recording-tab" [appTabStatus]="getTabStatusClass()">
          3.1.1 {{ t('steps.systemRecording') }}
        </p-tab>

        <p-tab
          [value]="1"
          data-testid="as-is-system-overview-tab"
          [appTabStatus]="getTabStatusClass()"
          [disabled]="detailTabsDisabled()"
        >
          3.1.2 {{ t('steps.asIsSystemOverview') }}
        </p-tab>

        <p-tab
          [value]="2"
          data-testid="to-be-system-overview-tab"
          [appTabStatus]="getTabStatusClass()"
          [disabled]="detailTabsDisabled()"
        >
          3.1.3 {{ t('steps.toBeSystemOverview') }}
        </p-tab>
      </p-tablist>

      <p-tabpanels class="mt-6" data-testid="step-3-1-tabpanels">
        <p-tabpanel [value]="0" data-testid="system-recording-tabpanel">
          <app-step-3-1-system-recording-editor />
        </p-tabpanel>

        <p-tabpanel [value]="1" data-testid="as-is-system-overview-tabpanel">
          @if (currentOfficeSystemRecordingResource.isLoading()) {
            <app-loading />
          } @else {
            <div class="card">
              <app-card-title key="project.steps.system.asIsSystemOverview" />
              <app-step-3-1-system-overview
                [officeSystemRecording]="currentOfficeSystemRecordingResource.value()!"
              ></app-step-3-1-system-overview>
              <app-system-recording-legend />
            </div>
          }
        </p-tabpanel>

        <p-tabpanel [value]="2" data-testid="to-be-system-overview-tabpanel">
          @if (targetOfficeSystemRecordingResource.isLoading()) {
            <app-loading />
          } @else {
            <div class="card">
              <app-card-title key="project.steps.system.toBeSystemOverview" />
              <app-step-3-1-system-overview
                [officeSystemRecording]="targetOfficeSystemRecordingResource.value()!"
              ></app-step-3-1-system-overview>
              <app-system-recording-legend />
            </div>
          }
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
}
